/*
 * @Description: 选择账号登陆 -- 表单校验
 * @Author: ljl
 * @Date: 2024-12-23
 */

import VALIDATOR from "../../../FormVerification/validator";

export const rules = {
  phoneNo: [{ required: true, validator: VALIDATOR.validatePhone, trigger: ["blur","change"] }],
  smsCode: [{ required: true, message: "  ", trigger: ["blur","change"] }]
};


// WEBPACK FOOTER //
// ./src/views/selectAccount/vdt/form_validata.js